import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Components.
import Row from './Row';
import Col from './Col';

// Siblings.
import './styles.css';

//------------------------------------------------------------------------------

const Grid = ({ children, className, gutter }) => {
  const classNameRoot = classNames('Grid', className);
  const padding = `${gutter}rem`;
  const styleRoot = { paddingLeft: padding, paddingRight: padding };
  return (
    <div className={classNameRoot} style={styleRoot}>
      {children}
    </div>
  );
};

Grid.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  gutter: PropTypes.number,
};

Grid.defaultProps = {
  className: null,
  gutter: 1,
};

export { Row, Col };
export default Grid;



// WEBPACK FOOTER //
// ./src/components/Grid/index.js